import React from 'react';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';


const ROLES = [
  { value: '', label: 'Todos los roles' },
  { value: 'SUPER_ADMIN', label: 'Super Admin' },
  { value: 'ADMIN', label: 'Admin' },
  { value: 'OPERATOR', label: 'Operador' },
  { value: 'CUSTOMER_USER', label: 'Usuario Cliente' },
];

const STATUSES = [
  { value: '', label: 'Todos los estados' },
  { value: 'ACTIVE', label: 'Activo' },
  { value: 'SUSPENDED', label: 'Suspendido' },
  { value: 'PENDING', label: 'Pendiente' },
];

const ORGANIZATIONS = [
  { value: '', label: 'Todas las organizaciones' },
  { value: 'techcorp', label: 'TechCorp S.A.S.' },
  { value: 'innovasoft', label: 'InnovaSoft Ltda.' },
  { value: 'datagroup', label: 'DataGroup Colombia' },
  { value: 'solucionesit', label: 'Soluciones IT S.A.' },
  { value: 'digitalco', label: 'DigitalCo S.A.S.' },
];

const UserFilters = ({ filters, onFilterChange, onClearFilters, totalResults }) => {
  const hasActiveFilters = filters?.search || filters?.role || filters?.status || filters?.organization;

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-4 md:p-5 shadow-sm">
      <div className="flex flex-col gap-3 md:gap-4">
        {/* Search */}
        <div className="flex-1">
          <div className="relative">
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
              <Icon name="Search" size={16} />
            </span>
            <input
              type="text"
              placeholder="Buscar por nombre, correo o NIT..."
              value={filters?.search}
              onChange={(e) => onFilterChange('search', e?.target?.value)}
              className="w-full pl-9 pr-4 py-2.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent font-body"
            />
          </div>
        </div>

        {/* Filter row */}
        <div className="flex flex-col sm:flex-row gap-3">
          <select
            value={filters?.role}
            onChange={(e) => onFilterChange('role', e?.target?.value)}
            className="flex-1 px-3 py-2.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 bg-white font-caption text-gray-700"
          >
            {ROLES?.map(r => <option key={r?.value} value={r?.value}>{r?.label}</option>)}
          </select>

          <select
            value={filters?.status}
            onChange={(e) => onFilterChange('status', e?.target?.value)}
            className="flex-1 px-3 py-2.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 bg-white font-caption text-gray-700"
          >
            {STATUSES?.map(s => <option key={s?.value} value={s?.value}>{s?.label}</option>)}
          </select>

          <select
            value={filters?.organization}
            onChange={(e) => onFilterChange('organization', e?.target?.value)}
            className="flex-1 px-3 py-2.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 bg-white font-caption text-gray-700"
          >
            {ORGANIZATIONS?.map(o => <option key={o?.value} value={o?.value}>{o?.label}</option>)}
          </select>

          {hasActiveFilters && (
            <Button variant="outline" size="sm" onClick={onClearFilters} iconName="X" iconPosition="left">
              Limpiar
            </Button>
          )}
        </div>

        {/* Results count */}
        <div className="flex items-center justify-between">
          <p className="text-xs text-gray-500 font-caption">
            {totalResults} usuario{totalResults !== 1 ? 's' : ''} encontrado{totalResults !== 1 ? 's' : ''}
          </p>
        </div>
      </div>
    </div>
  );
};

export default UserFilters;